import { REQUEST_STATUS } from '../constants';

export { REQUEST_STATUS };

export default {
  REQUEST_STATUS,
};
